(function () {
  const header = document.querySelector('.mt-header');
  if (!header) return;
  if (header.dataset.mtInit) return;
  header.dataset.mtInit = '1';

  /* ---- Scroll → compact mode ---- */
  header.classList.toggle('is-scrolled', window.scrollY > 40);
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
      ticking = false;
    });
  }, { passive: true });

  /* ---- Mega-menu hover intent ---- */
  const nav = header.querySelector('.mt-nav');
  if (nav) {
    let closeTimer = null;
    let currentMenu = null;

    const setMenu = (id) => {
      if (currentMenu === id) return;
      // Close previous
      if (currentMenu) {
        nav.querySelector(`.mt-mega[data-mega="${currentMenu}"]`)?.classList.remove('is-open');
        nav.querySelector(`.mt-navlink[data-nav="${currentMenu}"]`)?.classList.remove('is-open');
      }
      currentMenu = id;
      if (id) {
        nav.querySelector(`.mt-mega[data-mega="${id}"]`)?.classList.add('is-open');
        nav.querySelector(`.mt-navlink[data-nav="${id}"]`)?.classList.add('is-open');
      }
    };

    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => setMenu(null), 140);
    };

    const cancelClose = () => clearTimeout(closeTimer);

    nav.addEventListener('mouseleave', scheduleClose);

    nav.querySelectorAll('.mt-navlink[data-nav]').forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        cancelClose();
        const id = btn.dataset.nav;
        // Only open if a panel exists for this item
        if (nav.querySelector(`.mt-mega[data-mega="${id}"]`)) {
          setMenu(id);
        } else {
          setMenu(null);
        }
      });
    });

    nav.querySelectorAll('.mt-mega').forEach((panel) => {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
    });
  }

  /* ---- Mobile drawer ---- */
  const overlay  = document.querySelector('.mt-drawer-overlay');
  const drawer   = document.querySelector('.mt-drawer');
  const hamburger = header.querySelector('.mt-hdr-hamburger');
  const closeBtn  = drawer?.querySelector('.mt-drawer__close');

  const openDrawer = () => {
    overlay?.classList.add('is-open');
    drawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    hamburger?.setAttribute('aria-expanded', 'true');
  };

  const closeDrawer = () => {
    overlay?.classList.remove('is-open');
    drawer?.classList.remove('is-open');
    document.body.style.overflow = '';
    hamburger?.setAttribute('aria-expanded', 'false');
  };

  hamburger?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---- Mobile drawer sub-menus ---- */
  drawer?.querySelectorAll('.mt-drawer__item-btn[data-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id  = btn.dataset.toggle;
      const sub = drawer.querySelector(`.mt-drawer__sub[data-sub="${id}"]`);
      if (!sub) return;
      const isOpen = sub.classList.contains('is-open');
      // Collapse all
      drawer.querySelectorAll('.mt-drawer__sub').forEach((s) => s.classList.remove('is-open'));
      drawer.querySelectorAll('.mt-drawer__item-btn[data-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      // Toggle this one
      if (!isOpen) {
        sub.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---- Cart badge live update ---- */
  // Dawn publishes 'cart:refresh' via pubsub.js — listen for it
  const updateCartBadge = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? '' : 'none';
    });
    const cartBtn = document.getElementById('mt-cart-btn');
    if (cartBtn) {
      cartBtn.setAttribute('aria-label',
        count > 0
          ? `Open shopping bag, ${count} ${count === 1 ? 'item' : 'items'}`
          : 'Open shopping bag'
      );
    }
  };

  document.addEventListener('cart:refresh', (e) => {
    if (e.detail?.itemCount != null) updateCartBadge(e.detail.itemCount);
  });

  // Also respond to Dawn's section:load for theme editor compatibility
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.contains(header)) {
      // Re-run scroll check
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }
  });
})();
